import React from "react";
import "./Footer.css";

// Make sure you have Font Awesome installed:
// npm install --save @fortawesome/react-fontawesome @fortawesome/free-solid-svg-icons @fortawesome/free-brands-svg-icons

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope, faHeadset, faShoppingBag, faArrowRight
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF, faXTwitter, faInstagram, faTiktok, faAmazon,
  faCcVisa, faCcMastercard, faCcAmex, faCcPaypal, faCcDiscover
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png"
// import base_url from "../../api"; // Uncomment when newsletter API is ready

const Footer = () => {

  return (
    <footer>
      <div className="footer-container">
        <div className="footer-brand">
          <Link to="/"><img src={logo} className="logo" alt="Shawl Haus Logo" /></Link>
          <br></br>
          <Link to="/customization" className="view-products-link">
            View Products <FontAwesomeIcon icon={faArrowRight} />
          </Link>
          <div className="footer-contact">
            <a href="mailto:Contact@shawlhaus.com" className="footer-email">
              <FontAwesomeIcon icon={faEnvelope} /> Contact@shawlhaus.com
            </a>
          </div>
          <div className="social-icons">
            <a href="/" aria-label="Facebook" title="Facebook">
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="/" aria-label="Twitter" title="Twitter">
              <FontAwesomeIcon icon={faXTwitter} />
            </a>
            <a href="/" aria-label="Instagram" title="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="/" aria-label="TikTok" title="TikTok">
              <FontAwesomeIcon icon={faTiktok} />
            </a>
            <a href="/" aria-label="Amazon" title="Amazon">
              <FontAwesomeIcon icon={faAmazon} />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <h3>Information</h3>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/customization">Product</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            {/* <li><a href="/">Career</a></li>
            <li><a href="/">My Account</a></li> */}
          </ul>
        </div>

        <div className="footer-links">
          <h3>Customer Services</h3>
          <ul>
            <li><Link to="/ShippingPolicy">Shipping Policy</Link></li>
            <li><Link to="/ReturnsRefundPolicy">Return & Refund</Link></li>
            <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>
            <li><Link to="/Term-Conditions">Terms & Conditions</Link></li>
            {/* <li><a href="/">Orders FAQs</a></li>
            <li><a href="/">My Wishlist</a></li> */}
          </ul>
        </div>

        <div className="footer-contact-section">
          <h3>Get in Touch</h3>
          <p>We're here to help you with any questions or custom orders.</p>
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-item-header">
                <FontAwesomeIcon icon={faEnvelope} />
                <strong>Email</strong>
              </div>
              <a href="mailto:Contact@shawlhaus.com">
                Contact@shawlhaus.com
              </a>
            </div>
            <Link to="/contact">
              <div className="contact-item">
                <div className="contact-item-header">
                  <FontAwesomeIcon icon={faHeadset} />
                  <strong>Need Help?</strong>
                </div>
                Contact Us
              </div>
            </Link>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2026 <span className="brand">Shawl Haus</span>. All rights reserved.</p>
        <div className="payment-icons">
          <FontAwesomeIcon icon={faCcVisa} size="2x" />
          <FontAwesomeIcon icon={faCcMastercard} size="2x" />
          <FontAwesomeIcon icon={faCcAmex} size="2x" />
          <FontAwesomeIcon icon={faCcPaypal} size="2x" />
          <FontAwesomeIcon icon={faCcDiscover} size="2x" />
        </div>
      </div>
    </footer >
  );
};

export default Footer;
